export default __webpack_public_path__ + "static/media/groundplan_d_108.99d31a30.png";